import { Injectable } from "@angular/core";
import { Observable, forkJoin } from "rxjs";

import { ProgramsModel } from "./models/programs.model";
import { HttpClient } from "@angular/common/http";
import { CourseCompleteRequest, ProgramBulkRequest, ProgramCompleteRequest, TopicCompleteRequest } from "./models/course-complete-request.model";
import { EmployeeProfile } from "./models/employee-profile.model";
import { environment } from "src/environments/environment";
@Injectable({
    providedIn: 'root'
})
export class EmployeeCareerProgramService {

    private Ecp_api = environment.apiUrl;
    constructor(private http: HttpClient) { }

    public getAssignedPrograms(programDetails: ProgramsModel) : Observable<any> | null {
        return this.http.post(`${this.Ecp_api}ECPUser/FetchAllProgramsOfEmployee`, programDetails);
    }

    public getTrendingProgarms(model: any) {
        return this.http.post(`${this.Ecp_api}ECPUser/FetchTrendingProgramsOfEmployee`,model);
    }

    public getEmployeeProgramDetail(userID: number, programID: number) { 
        return this.http.get(`${this.Ecp_api}Program/GetEmployeeProgramDetail?` + 'programID=' + programID + '&userID=' + userID);
    }

    public getRecommendedPrograms(model: ProgramsModel) : Observable<any> | null {
        return this.http.post(`${this.Ecp_api}ECPUser/FetchRecommendedProgramsOfEmployee`, model);
    }

    public revokeProgram(programId: any) {
        return this.http.put(`${this.Ecp_api}LearningTrack/RevokeProgram`, programId);
    }

    public revokeCourse(courseId: any) {
        return this.http.put(`${this.Ecp_api}LearningTrack/RevokeCourse`, courseId);
    }

    public revokeTopic(topicId:any) {
        return this.http.put(`${this.Ecp_api}LearningTrack/RevokeTopic`, topicId);
    }

    public getAllPracticesAndDepartments() {
        return this.http.get(`${this.Ecp_api}ECPUser/FetchAllPracticesAndDepartments`);
    }

    public getAllPrograms(model: any) {
        return this.http.post(`${this.Ecp_api}Program/SearchInPrograms/`, model);
    }
    public getCMFProgramListByCompetency(competencyId: number, subCompetencyId: number) {
     return this.http.get(`${this.Ecp_api}TrainingSession/getCMFProgramListByCompetency?` + 'competencyId=' + competencyId + '&subCompetencyId=' + subCompetencyId);
    }
    public requestProgram(requestedProgram: any) {
        return this.http.post(`${this.Ecp_api}Program/RequestAprogram`, requestedProgram);
    }
    public assignPrograms(assignProgram: any) {
        return this.http.post(`${this.Ecp_api}Program/AssignPrograms`, assignProgram);
    }

    public elasticSearch(searchKey: string, pageSize: number, pageNumber: number) {
        return this.http.get(`${this.Ecp_api}Program/Search?` + "searchKey=" + searchKey + "&pageSize=" + pageSize + "&pageNumber=" + pageNumber);
    }

    public getMyHeirarchy(userID:string){
      return this.http.get(`${this.Ecp_api}ECPUser/GetManagerHierarchy?managerId=${userID}`);
    }

    public globalSearch(model) :  Observable<any[]> {
        let response1 = this.http.post(`${this.Ecp_api}ECPUser/FetchAllProgramsOfEmployee/`, model);
        let response2 = this.http.post(`${this.Ecp_api}ECPUser/FetchRecommendedProgramsOfEmployee/`, model);
        let response3 = this.http.post(`${this.Ecp_api}ECPUser/FetchTrendingProgramsOfEmployee`,model);
        return forkJoin([response1, response2, response3]);
    }

    public removeCertificate(courseTrackID,attachmentID):any{
      // return this.http.delete("api/Course/DeleteCourseCertificateById?"+"employeeCourseTrackId=" + courseTrackID + "&attachementId=" + attachmentID);

     return this.http.delete(`${this.Ecp_api}Course/DeleteCourseCertificateById?`+"employeeCourseTrackId="+courseTrackID+"&attachementId="+attachmentID);
    }


    public GetEmployeeUpcomingPrograms(userID: number, searchText: string = ''): Observable<any> {
        return this.http.get(`${this.Ecp_api}Program/GetEmployeeUpcomingPrograms?` + 'userID=' + userID + '&searchText=' + searchText);
      }

      public GetEmployeeCurrentPrograms(employeeProfile: EmployeeProfile){
        return this.http.post(`${this.Ecp_api}Program/GetEmployeeCurrentPrograms`, employeeProfile);
      }

    //   public GetEmployeePreviousPrograms(datatableFilter: DataTableFilter) {
    //     return this.http.post("api/Program/GetEmployeePreviousPrograms", datatableFilter);
    //   }

      public GetEmployeeCourseDetail(courseID: number, userID: number) {
        return this.http.get(`${this.Ecp_api}Course/GetEmployeeCourseDetail?` + 'courseID=' + courseID + '&userID=' + userID);
      }

      public GetEmployeeProgramDetail(programID: number, userID: number) {
        return this.http.get(`${this.Ecp_api}Program/GetEmployeeProgramDetail?` + 'programID=' + programID + '&userID=' + userID);
      }

      public GetEmployeeCareerPath(userID: string) {
        return this.http.get(`${this.Ecp_api}EmployeeCareer/GetEmployeeCareerPath?userId=${userID}`);
      }

      public completeCourse(courseCompleteRequest: CourseCompleteRequest) {
        return this.http.put(`${this.Ecp_api}LearningTrack/CompleteCourse`, courseCompleteRequest);
      }

      public completeTopic(topicCompleteRequest: TopicCompleteRequest) {
        return this.http.put(`${this.Ecp_api}LearningTrack/CompleteTopic`, topicCompleteRequest);
      }

      public startProgram(programStartRequest: ProgramCompleteRequest) {
        return this.http.post(`${this.Ecp_api}LearningTrack/StartProgram`, programStartRequest);
      }

      public startCourse(courseStartRequest: CourseCompleteRequest) {
        return this.http.post(`${this.Ecp_api}LearningTrack/StartCourse`, courseStartRequest);
      }

      public startTopic(topicStartRequest: TopicCompleteRequest) {
        return this.http.post(`${this.Ecp_api}LearningTrack/StartTopic`, topicStartRequest);
      }

      public completeProgram(programCompleteRequest: ProgramCompleteRequest) {
        return this.http.put(`${this.Ecp_api}LearningTrack/CompleteProgram`, programCompleteRequest);
      }

      public completeProgramList(programTrackDTO: ProgramBulkRequest) {
        return this.http.put(`${this.Ecp_api}LearningTrack/CompleteProgram`, programTrackDTO);
      }

      public revokeProgramList(programTrackDTO: ProgramBulkRequest, userId:number) {
        return this.http.put(`${this.Ecp_api}LearningTrack/RevokeProgram?userId=${userId}`, programTrackDTO.programIds);
      }

      public getDistinctsubGroups() {
        return this.http.get(`${this.Ecp_api}Program/GetDistinctsubGroups`);
      }
      public getFileDownloadLink(imageId : string) : Observable<any> {
        return this.http.get<any>(`${this.Ecp_api}ECPUser/GetProgramImage?fileId=${imageId}`)
      }
    updateProgramRequest(progData, empID){
      return this.http.post(`${this.Ecp_api}Program/UpdateAProgramRequest?`+'currentEmpId=' + empID,progData);
    }
      
  public getTeamDetails(TeamDetailsModel) {
    return this.http.post<any>(`${this.Ecp_api}Program/GetTeamAssignProgramDetails`, TeamDetailsModel);
  }
}
